import PropTypes from 'prop-types';
import styles from './FJTextToImageRight.module.less';
import FJDisplayHeaderContainer from '../../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer';
import FJCreationPanelContainer from '../../../FJMainPreview/FJCreationPanel/FJCreationPanelContainer';
import FJHistoryPanelContainer from '../../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer';

const FJTextToImageRight = props => {
    const { isShowPresetImageBox } = props;
    return (
        <div className={styles.app_right}>
            <FJDisplayHeaderContainer />

            <FJCreationPanelContainer
                activeHeaderTabIndex={0}
                hideCompare={true}
                isShowPresetImageBox={isShowPresetImageBox}
            />

            <FJHistoryPanelContainer activeHeaderTabIndex={1} />
        </div>
    );
};

FJTextToImageRight.propTypes = {
    isShowPresetImageBox: PropTypes.bool,
};

export default FJTextToImageRight;
